function getWalletTenantConfig() {
  let tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // Only BOA has different settings
  if (tenant === 'BOA') {
    return {
      disableCreditTierSelection: true,
      hideWalletId: true,
      hideWalletSyncBanner: true,
      defaultCreditType: 'a',
      disableCustomInterestRate: true
    };
  }
  return {};
}
export { getWalletTenantConfig as default };
